var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tiptap',{ref:"miEditor",class:`${_vm.readMode ? 'hide-border' : ''}`,attrs:{"content":_vm.contentForEditor,"extensions":_vm.extensions,"output":"json","lang":"es","tooltip":true,"readonly":_vm.readMode,"show-menubar":!_vm.readMode,"char-counter-count":!_vm.readMode},on:{"onUpdate":_vm.onEditorUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }